import { buildCommonFilters } from './common'
import { kindFilters } from './kind'
import { BuildFiltersProps, HaystackFilterProp } from './types'

export const buildFilters = (
  { params }: BuildFiltersProps,
  haystackKinds?: string[]
): HaystackFilterProp[] => [...buildCommonFilters(params), ...kindFilters(haystackKinds, params)]
